import React,{useState} from "react";
import {
    AiFillFacebook,
    AiFillInstagram,
    AiFillLinkedin,
    AiFillTwitterCircle,
    AiFillYoutube,
  } from "react-icons/ai";
  import { HashLink } from "react-router-hash-link";
  import logo from "../pictures/logo.png";
  import { Link } from "react-router-dom";
  import { BiSolidDownArrow } from "react-icons/bi";
  import {AiOutlineClose} from "react-icons/ai";
  import {GiHamburgerMenu} from "react-icons/gi";
import CompanyButton from "./CompanyButton";

const Header = () =>
{
  const [sidebar, setSidebar] = useState(false);

  const showSidebar = () => setSidebar(!sidebar);


  
    return(
        <>
         <div className="HamNav">
          <div className="logo">
            <img src={logo}/>
          </div>
           <Link to={'/'} className='ham_menu'>
            <GiHamburgerMenu onClick={showSidebar} size={20} color="yellow"/>
           </Link>
           <Link to={'/'} className='tab_ham_menu'>
            <GiHamburgerMenu onClick={showSidebar} size={40} color="yellow"/>
           </Link>
         </div>

        <nav className={sidebar ? 'nav_menu active' : 'nav_menu'}>
        <div className="logo">
            <img src={logo}/>
          </div>
          <ul className="nav_menu_items">
            <li className="navbar_toggle">
            <Link to={'/'} className="ham_menu">
             <AiOutlineClose onClick={showSidebar} size={20} color="yellow"/>
            </Link>
            <Link to={'/'} className="tab_ham_menu">
             <AiOutlineClose onClick={showSidebar} size={40} color="yellow"/>
            </Link>
            </li>

            <div className="mobile_nav_link">
           
          <HashLink to={"/#home"} onClick={showSidebar}>HOME</HashLink>

           <Link to={'/'}>Company<BiSolidDownArrow />
            <div className="company_dropdown_menu">
               <Link to={"/Company_About"} onClick={showSidebar}>Company_About</Link> 
                <Link to={"/Our_Mission"} onClick={showSidebar}>Our Mission</Link>   
                <Link to={"/Our_Values"} onClick={showSidebar}>Our Values</Link>     
             </div>
             </Link>
         
          <Link to={"/About_Education_Award"} onClick={showSidebar} className="hover_awards">ABOUT EDUCATION AWARD</Link>
          <Link to={"/Other_Award"} onClick={showSidebar}>OTHER AWARD</Link>
          <Link to={"/Guest_And_Speaker"} onClick={showSidebar}>GUEST AND SPEAKER</Link>
          <Link to={"/"}>GALLERY <BiSolidDownArrow /> 
          <div className="gallery_dropdown_menu">
           <Link to={"/Photo"} onClick={showSidebar}>Photo</Link> 
           <Link to={"/Video"} onClick={showSidebar}>Video</Link>   
           </div>
          </Link>
          <Link to={"/FAQ"} onClick={showSidebar}>FAQ</Link>
          <Link to={"/Nomination"} onClick={showSidebar} className="nomination_header_link">NOMINATION</Link>
          <Link to={"/Contact_us"} onClick={showSidebar}>CONTACT US</Link>
          </div>
           </ul>
        </nav>

         <nav className="nav_1">
        <div className="phone_numbers">
          <h2> For More Detail Call +91-9821020995, +91-9873004416</h2>
        </div>
        <div className="social_media_icons">
          <span className="icons facebook">
            <a
              href="https://www.facebook.com/TimeCyberMedia/"
              target="_blank"
              rel="noreferrer"
            >
              <AiFillFacebook />
            </a>
          </span>
          <span className="icons twitter">
            <a
              href="https://twitter.com/i/flow/login?redirect_after_login=%2Ftimecybermedia"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              <AiFillTwitterCircle />{" "}
            </a>
          </span>
          <span className="icons youtube">
            <a
              href="https://www.youtube.com/@timecybermedia7561"
              target="_blank"
              rel="noreferrer"
            >
              <AiFillYoutube />
            </a>
          </span>
          <span className="icons linkedin">
            <a
              href="https://www.linkedin.com/company/time-cyber-media-pvt.-ltd"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              <AiFillLinkedin />
            </a>
          </span>
          <span className="icons instagram">
            <a
              href="https://www.instagram.com/timecybermedia/?igshid=YmMyMTA2M2Y%3D"
              target="_blank"
              rel="noreferrer"
            >
              <AiFillInstagram />
            </a>
          </span>
        </div>
      </nav>
      <nav className="nav_2">
        <div className="logo">
       <img src={logo}/>
        </div>
        <main className="header_links">
          <HashLink to={"/#home"}>HOME</HashLink>
          <Link to={"/"}>COMPANY <BiSolidDownArrow />
          <div className="company_dropdown_menu">
           <Link to={"/Company_About"}>Company_About</Link> 
           <Link to={"/Our_Mission"}>Our Mission</Link>   
           <Link to={"/Our_Values"}>Our Values</Link>     
           </div>
           </Link>
          <Link to={"/About_Education_Award"} className="hover_awards">ABOUT EDUCATION AWARD</Link>
          <Link to={"/Other_Award"} >OTHER AWARD</Link>
          <Link to={"/Guest_And_Speaker"}>GUEST AND SPEAKER</Link>
          <Link to={"/"}>GALLERY <BiSolidDownArrow /> 
          <div className="gallery_dropdown_menu">
           <Link to={"/Photo"}>Photo</Link> 
           <Link to={"/Video"}>Video</Link>   
           </div>
          </Link>
          <Link to={"/FAQ"}>FAQ</Link>
          <Link to={"/Nomination"} className="nomination_header_link">NOMINATION</Link>
          <Link to={"/Contact_us"}>CONTACT US</Link>
        </main>

      

        {/* <div className="mobile_menu_bar">
          <CgMenu
            className="mobile_nav_icon menu_outline"
            onClick={() => setOpenMenu(true)}
          />
          <CgClose
            className="mobile_nav_icon close_outline"
            onClick={() => setOpenMenu(false)}
          />
        </div> */}
      </nav>
        </>
    )
}

export default Header;